import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Box,
  Typography,
  IconButton,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Close, ContentCopy } from "@mui/icons-material";

interface ShareSuccessPopupProps {
  open: boolean;
  onClose: () => void;
  shareUrl: string;
}

const ShareSuccessPopup: React.FC<ShareSuccessPopupProps> = ({ open, onClose, shareUrl }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery('(max-width: 768px)');

  const handleCopyLink = async () => {
    await navigator.clipboard.writeText(shareUrl);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      fullScreen={isMobile}
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: isMobile ? 0 : "16px",
          margin: isMobile ? 0 : "32px",
          maxHeight: isMobile ? "100vh" : "calc(100vh - 64px)",
        },
      }}
    >
      <DialogTitle sx={{ 
        padding: isMobile ? "16px 20px" : "24px 24px 0 24px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between"
      }}>
        <Typography sx={{ 
          fontSize: isMobile ? "18px" : "20px", 
          fontWeight: "600",
          fontFamily: "DM Sans",
          color: "#000105"
        }}>
          Share Link Created Successfully!
        </Typography>
        <IconButton
          onClick={onClose}
          sx={{
            color: "#666",
            padding: "8px",
            "&:hover": {
              backgroundColor: "#f5f5f5",
            },
          }}
        >
          <Close />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ padding: isMobile ? "16px 20px 20px 20px" : "24px" }}>
        <Box sx={{
          backgroundColor: "#E8F5E8",
          border: "1px solid #4CAF50",
          borderRadius: "8px",
          padding: "16px",
          marginBottom: "24px",
          display: "flex",
          flexDirection: "column",
          gap: "12px"
        }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <Box sx={{ 
              width: "24px", 
              height: "24px", 
              backgroundColor: "#4CAF50", 
              borderRadius: "50%", 
              display: "flex", 
              alignItems: "center", 
              justifyContent: "center" 
            }}>
              <Typography sx={{ color: "white", fontSize: "16px" }}>✓</Typography>
            </Box>
            <Typography sx={{ 
              color: "#2E7D32", 
              fontWeight: "600", 
              fontSize: "16px",
              fontFamily: "DM Sans"
            }}>
              Share link has been created successfully!
            </Typography>
          </Box>
        </Box>
        
        <Box sx={{ marginBottom: "24px" }}>
          <Typography sx={{ 
            fontSize: "14px", 
            fontWeight: "600",
            fontFamily: "DM Sans",
            color: "#333",
            marginBottom: "8px"
          }}>
            Share Link:
          </Typography>
          
          <Box sx={{ 
            backgroundColor: "white", 
            border: "1px solid #E0E0E0", 
            borderRadius: "6px", 
            padding: "12px",
            display: "flex",
            alignItems: "center",
            gap: "8px"
          }}>
            <Typography sx={{ 
              color: "#333", 
              fontSize: "14px",
              fontFamily: "DM Sans",
              flex: 1,
              wordBreak: "break-all"
            }}>
              {shareUrl}
            </Typography>
            <Button
              onClick={handleCopyLink}
              startIcon={<ContentCopy />}
              sx={{
                minWidth: "auto",
                padding: "8px 16px",
                backgroundColor: "#756DE9",
                color: "white",
                borderRadius: "6px",
                fontSize: "14px",
                textTransform: "none",
                fontWeight: "500",
                "&:hover": {
                  backgroundColor: "#5f5bc4",
                }
              }}
            >
              Copy
            </Button>
          </Box>
        </Box>

        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: "12px" }}>
          <Button
            onClick={onClose}
            sx={{
              padding: "10px 24px",
              backgroundColor: "#756DE9",
              color: "white",
              borderRadius: "8px",
              fontSize: "14px",
              textTransform: "none",
              fontWeight: "500",
              "&:hover": {
                backgroundColor: "#5f5bc4",
              }
            }}
          >
            Done
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ShareSuccessPopup;
